export const INTERNAL_NAME_MAX_LENGTH = 255;
export const SUBJECT_MAX_LENGTH = 140;
export const PREVIEW_TEXT_MAX_LENGTH = 140;
